import { useRef, useState, useEffect } from 'react';
import './TimeSlotSlider.css';

export default function TimeSlotSlider({ slots = [], selected, onSelect }) {
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  useEffect(() => {
    updateScrollStatus();
  }, [slots]);

  const updateScrollStatus = () => {
    const el = scrollRef.current;
    if (!el) return;

    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth);
  };

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -150, behavior: 'smooth' });
    setTimeout(updateScrollStatus, 300);
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 150, behavior: 'smooth' });
    setTimeout(updateScrollStatus, 300);
  };

  return (
    <div className="timeslot-container">
      <button type="button" className={`timeslot-arrow ${!canScrollLeft ? 'disabled' : ''}`} onClick={scrollLeft} disabled={!canScrollLeft}>
        <i className="ph ph-arrow-left"></i>
      </button>

      <div className="timeslot-scroll" ref={scrollRef} onScroll={updateScrollStatus}>
        {slots.map((slot) => {
          const isActive = selected === slot.value;

          return (
            <button
              type="button"
              key={slot.value}
              className={`timeslot-pill ${isActive ? 'active' : ''} ${slot.isFullyBooked ? 'disabled' : ''}`}
              disabled={slot.isFullyBooked}
              onClick={() => onSelect(slot.value)}
              title={slot.isFullyBooked ? 'Fully booked' : slot.availableSeats != null ? `${slot.availableSeats} seats available` : ''}
            >
              {slot.label}
            </button>
          );
        })}
      </div>

      <button
        type="button"
        className={`timeslot-arrow ${!canScrollRight ? 'disabled' : ''}`}
        onClick={scrollRight}
        disabled={!canScrollRight}
      >
        <i className="ph ph-arrow-right"></i>
      </button>
    </div>
  );
}
